// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-card__desc{position:relative;max-height:70px;margin-top:5px;color:var(--z2kad5);font-size:14px;line-height:22px;overflow:hidden}.media-card__desc:after{content:\"\";position:absolute;width:30%;height:22px;right:0;bottom:0;background:linear-gradient(270deg,#fff 15%,hsla(0,0%,100%,0))}", ""]);
// Exports
module.exports = exports;
